import { createSignal } from "solid-js"

export type SeenPlayer = {
    id: string
    name: string
}

const seenPlayersKey = 'repo-save-player-swap__seen-players'

const [getSeenPlayersSignal, setSeenPlayersSignal] = createSignal<SeenPlayer[]>(JSON.parse(localStorage.getItem(seenPlayersKey) ?? '[]'))

export function setSeenPlayers(seenPlayers: SeenPlayer[]) {
    localStorage.setItem(seenPlayersKey, JSON.stringify(seenPlayers))
    setSeenPlayersSignal(seenPlayers)
}

export const getSeenPlayers = getSeenPlayersSignal